const INITIAL_STATE = {
    methodItems: [],
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        default: {
            return state;
        }
    }
}